export enum TableColumn {
    adType = 'adType',
    advertiserName = 'advertiserName',
    advertiserDomain = 'advertiserDomain',
    aiAdType = 'aiAdType',
    aiAdvertisers = 'aiAdvertisers',
    aiIndustries = 'aiIndustries',
    aiCategories = 'aiCategories',
    aiProducts = 'aiProducts',
    aiFuelTypes = 'aiFuelTypes',
    brand = 'brand',
    category = 'category',
    complianceRanking = 'complianceRanking',
    complianceReason = 'complianceReason',
    firstAppeared = 'firstAppeared',
    industry = 'industry',
    lastAppeared = 'lastAppeared',
    mediaOwner = 'mediaOwner',
    mediaType = 'mediaType',
    product = 'product',
    region = 'region',
    status = 'status',
    publisher = 'publisher',
    publication = 'publication',
    country = 'country',
    campaignName = 'campaignName',
    creative = 'creative',
    ads = 'ads'
}
